export const paymentHistoryExportColumns = [
	{ label: 'Sr No', key: 'index' },
	{
		label: 'Community',
		render: f => f?.hub?.name || '',
	},
	{
		label: 'Sanstha',
		render: f => f?.sansthaId?.name || '',
	},
	{
		label: 'User Name',
		render: f => (f?.userId ? `${f.userId.firstName || ''} ${f.userId.lastName || ''}`.trim() : ''),
	},
	{
		label: 'User Mobile',
		render: f => f?.userId?.mobile || '',
	},
	{
		label: 'Contribution Type',
		render: f => f?.fundraisingType || '',
	},
	{
		label: 'Payment Type',
		render: f => (f?.isOnline ? 'Online' : 'Offline'),
	},
	{
		label: 'Amount',
		render: f => f?.amount ?? '',
	},
	{
		label: 'Payment Mode',
		render: f => f?.offlinePaymentMode || '',
	},
	{
		label: 'Payment Reference No',
		render: f => f?.paymentRef || '',
	},
	{
		label: 'Payment Date',
		render: f => (f?.paymentDate ? new Date(f.paymentDate).toLocaleDateString('en-IN') : ''),
	},
]
